import React from "react";
import styled from "styled-components";
import { usePermission } from "../../../../../hooks/use-permission";

type FieldSyncBadgeKind = "backend" | "local" | "mock" | "partial" | "ia";

type FieldSyncBadgeProps = {
  kind: FieldSyncBadgeKind;
  label?: string;
};

const labels: Record<FieldSyncBadgeKind, string> = {
  backend: "Backend",
  local: "Local",
  mock: "Sem endpoint",
  partial: "Parcial",
  ia: "IA",
};

const ariaLabels: Record<FieldSyncBadgeKind, string> = {
  backend: "Campo sincronizado com backend",
  local: "Campo salvo somente neste navegador",
  mock: "Campo sem endpoint de backend",
  partial: "Campo com sincronizacao parcial",
  ia: "Campo preenchido por sugestao de IA",
};

/* Marcador interno de auditoria: um ponto com o texto no title, para não brigar com o formulário. */
const Badge = styled.span<{ $kind: FieldSyncBadgeKind }>`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  flex-shrink: 0;
  font-size: 0;
  ${({ $kind }) => {
    if ($kind === "backend") return "background: #1E8E3E;";
    if ($kind === "mock") return "background: #F9AB00;";
    if ($kind === "partial") return "background: #1264C7;";
    if ($kind === "ia") return "background: #7c3aed;";
    return "background: #9AA0A6;";
  }}
`;

export const FieldSyncBadge: React.FC<FieldSyncBadgeProps> = ({
  kind,
  label,
}) => {
  // Rotulos tecnicos de auditoria (Backend / Sem endpoint / ...) sao ferramenta
  // interna. O cliente final NAO deve ve-los no proprio perfil: so admin/staff.
  const { isAdmin } = usePermission();
  if (!isAdmin) return null;

  return (
    <Badge $kind={kind} aria-label={ariaLabels[kind]} title={label || labels[kind]}>
      {label || labels[kind]}
    </Badge>
  );
};
